"use strict";

exports.__esModule = true;
var _PasswordEditor = require("./PasswordEditor");
Object.keys(_PasswordEditor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PasswordEditor[key]) return;
  exports[key] = _PasswordEditor[key];
});